import React from "react";
import { FiGift, FiHeart, FiUsers, FiStar } from "react-icons/fi";

const categories = [
  { key: "birthday", label: "تولد", icon: FiGift },
  { key: "date", label: "دیت", icon: FiHeart },
  { key: "family", label: "خانواده", icon: FiUsers },
  { key: "vip", label: "VIP", icon: FiStar },
];

const OccasionFilterSection = ({ selected, onSelect }) => {
  return (
  <div className="w-full mb-14">
  <div className="w-full">
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-y-8 gap-x-4 w-full text-center">
      {categories.map((item) => {
        const Icon = item.icon;
        const isActive = selected === item.key;

        return (
          <button
            key={item.key}
            onClick={() => onSelect(isActive ? null : item.key)}
            className="group relative flex flex-col items-center gap-3 transition-all duration-300"
          >
            <Icon
              size={22}
              className={`transition-all duration-300
                ${
                  isActive
                    ? "text-primary scale-110"
                    : "text-gray-500 group-hover:text-primary group-hover:scale-105"
                }
              `}
            />

            <span
              className={`text-sm font-medium transition-colors
                ${
                  isActive
                    ? "text-primary"
                    : "text-gray-700 group-hover:text-primary"
                }
              `}
            >
              {item.label}
            </span>

            {/* underline indicator */}
            <span
              className={`absolute -bottom-3 h-[2px] w-8 rounded-full transition-all duration-300
                ${
                  isActive
                    ? "bg-primary opacity-100"
                    : "bg-primary opacity-0 group-hover:opacity-40"
                }
              `}
            />
          </button>
        );
      })}
    </div>
  </div>
</div>
  );
};

export default OccasionFilterSection;